export default "__VITE_ASSET__ec76919c__"